// extracted by mini-css-extract-plugin
export var childrenContainer = "_4a-0";
export var virtualScrollArea = "_4a-1";